<template>
  <!-- Component not used. Left for better times. -->
  <span>
    <v-btn v-if="interactive" :height="size" :width="size" @click="$emit('click')" text small icon>
      <v-icon :color="color" :size="size">
        {{ getLayerIcon(layerType) }}
      </v-icon>
    </v-btn>
    <v-icon v-else :color="color" :size="size">
      {{ getLayerIcon(layerType) }}
    </v-icon>
  </span>
</template>

<script>
import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';

export default {
  name: 'LegendLayerListIcon',
  mixins: [stylePreviewUtilities],
  props: {
    interactive: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: true,
    },
    layerType: {
      type: String,
    },
    size: {
      type: [Number, String],
      default: '24px',
    },
  },
};
</script>
